import { SET_LOADER, GET_GAS_STATION_OWNERSHIO_REQUEST_BY_ID } from "./types";
import { apiService } from "../utils/serviceApi";

export const getGasStationOwnershipRequestById =
  (requestId) => async (dispatch) => {
    dispatch({
      type: SET_LOADER,
      payload: true,
    });
    apiService
      .get(
        `${process.env.REACT_APP_SERVICE_URL}/api/gas-station-ownership/${requestId}`
      )
      .then((res) => {
        dispatch({
          type: GET_GAS_STATION_OWNERSHIO_REQUEST_BY_ID,
          payload: res.data,
        });
      })
      .catch((e) => {
        console.log(e);
      })
      .finally(() => {
        dispatch({
          type: SET_LOADER,
          payload: false,
        });
      });
  };
